let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("ewSSf"), load("ffEVr"), load("ab8Aq")]).then(() => parcelRequire('4TDF1'));